import api from '@/api/api.js'

export default {
    getActiveCompteForUser(idUser) {
        const promise = api.comptabilite().get('/compte/' + idUser)
        return promise.then((response) => response.data)
    },

    /**
     * Recupère la date d'uverture (J) d'une caisse non cloturée à
     * une date J+n
     * @param {*} compte_id 
     * @returns 
     */
    getDateOuvertureCaisseNonCloturee(compte_id) {
        const promise = api.comptabilite().get('/comptes/' + compte_id + '/date_overture_caisse_non_cloturee')
        return promise.then((response) => response.data)
    },

    /**
     * Vérifie le statut d'ouverture d'une caisse
     * @param {*} compte_id 
     * @returns 
     */
    getStatutOuvertureCaisse(compte_id) {
        const promise = api.comptabilite().get('/comptes/' + compte_id + '/etat_ouverture')
        return promise.then((response) => response.data)
    },

    /**
     * Recupère le dernier solde de cloture d'une caisse donnée
     * @param {*} $compte_id 
     */
    getDernierSoldeCloture(compte_id) {
        const promise = api.comptabilite().get('/comptes/' + compte_id + '/solde')
        return promise.then((response) => response.data)
    },

    /**
     * Ouvrir une caisse
     * @param {*} data 
     * @returns 
     */
    openCaisse(data) {
        const promise = api.comptabilite().post('/comptes/ouvrir-caisse', data)
        return promise.then((response) => response.data)
    },

    /**
     * Cloturer une caisse
     * @param {*} data 
     * @returns 
     */
    closeCaisse(data) {
        const promise = api.comptabilite().post('/comptes/cloturer-caisse', data)
        return promise.then((response) => response.data)
    },

    /**
     * Cloturer une caisse avec versement
     * @param {*} data 
     * @returns 
     */
    closeCaisseVersement(data) {
        const promise = api.comptabilite().put('/comptes/cloturer_caisse_versement', data)
        return promise.then((response) => response.data)
    },

    /**
     * Faire un versement
     * @param {*} data 
     * @returns 
     */
    doCaisseVersement(data) {
        const promise = api.comptabilite().post('/caisse-operations/caisse-versement', data)
        return promise.then((response) => response.data)
    },
    /**
     * Prendre les types dépenses en fonction du rôle de l'utilisateur
     * @param {*} data 
     * @returns 
     */
    getTypeDepenses(idRole) {
        const promise = api.comptabilite().get('/role/' + idRole + '/type_depenses')
        return promise.then((response) => response.data)
    },

    saveSourceDepense(data){
        const promise = api.comptabilite().post('/ligne-budgetaire/store', data);
        return promise.then((response) => response.data)
    },

    getDotation(data){
        const promise = api.comptabilite().post('/ligne-budgetaire/dotation/liste', data);
        return promise.then((response) => response.data)
    },

    getLigneBudgetaire(role_id){
        const promise = api.comptabilite().get('/ligne-budgetaire/role/'+role_id+'/liste');
        return promise.then((response) => response.data)
    },

    deleteLigneBudgetaire(data){
        const promise = api.comptabilite().post('/ligne-budgetaire/delete', data);
        return promise.then((response) => response.data)
    },

    getAllLigneBudgetaire(){
        const promise = api.comptabilite().get('/ligne-budgetaire');
        return promise.then((response) => response.data)
    },

    getSommeLigneBudgetaire(ligne_budgetaire){
        const promise = api.comptabilite().get('/ligne-budgetaire/'+ligne_budgetaire+'/cumul-depense');
        return promise.then((response) => response.data)
    },

    getListeSourceApprovisionnement(){
        const promise = api.comptabilite().get('/comptes/source-approvisionnement');
        return promise.then((response) => response.data)
    },

    saveDotation(data){
        const promise = api.comptabilite().post('/ligne-budgetaire/dotation/store', data);
        return promise.then((response) => response.data)
    },

    deleteDotation(data){
        const promise = api.comptabilite().post('/ligne-budgetaire/dotation/delete', data);
        return promise.then((response) => response.data)
    },

    getHistoriqueDotation(data){
        const promise = api.comptabilite().post('/ligne-budgetaire/dotation/historique', data);
        return promise.then((response) => response.data)
    },

    deleteItem(data){
        const promise = api.comptabilite().post('/items/delete', data)
        return promise.then(response => response.data)
    },

    getEtatOuvertureCaisse(data){
        const promise = api.comptabilite().post('/comptes/etat-ouverture-caisse', data)
        return promise.then(response => response.data)
    },
}